import { PlusCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Button, notification, Space, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { StatePieceStatus } from '../../../../../enums';
import { IInvoiceStatusLookupListTableRow } from '../../../../../interfaces/lookup/invoiceStatus';
import { ContentHeader } from '../../../../../shared/components/appSkeleton/contentHeader/ContentHeader';
import { NOTIFICATION_PLACEMENT } from '../../../../../shared/Constants';
import { AppDispatch, RootState } from '../../../../../store';
import { fetchInvoiceStatuses } from '../../../../../store/lookupSlice/LookupActions';
import { resetState } from '../../../../../store/lookupSlice/LookupSlice';

export const InvoiceStatusLookupListOverview = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { invoiceStatuses } = useSelector((state: RootState) => state.lookupSlice);

    const columns: ColumnsType<IInvoiceStatusLookupListTableRow> = [
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
            render: (_, record) => (
                <>
                    <Tooltip title={record.description}>{record.code}</Tooltip>
                </>
            ),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            width: 100,
            render: (_, record) => (
                <Space size="middle">
                    <Button
                        type="text"
                        icon={<RightOutlined />}
                        onClick={() => navigate(`/admin/lookup-lists/invoice-status/${record.id}`)}
                    />
                </Space>
            ),
        },
    ];

    useEffect(() => {
        if (invoiceStatuses.updateStatus === StatePieceStatus.Success) {
            navigate('/admin/lookup-lists/invoice-status', { replace: true });
        }
    }, [invoiceStatuses.updateStatus]);

    useEffect(() => {
        dispatch(fetchInvoiceStatuses());

        return () => {
            dispatch(resetState());
        };
    }, []);

    useEffect(() => {
        if (invoiceStatuses.fetchStatus === StatePieceStatus.Error) {
            notification.error({
                message: 'An error occurred.',
                duration: 0,
                description: 'An error occurred while retrieving the data. Please contact your administrator if the problem persists.',
                placement: NOTIFICATION_PLACEMENT,
            });
        }
    }, [invoiceStatuses.fetchStatus]);

    return (
        <div className="app-page">
            <ContentHeader
                title="Manage invoice statuses lookup list"
                breadcrumbs={[
                    {
                        breadcrumbName: 'Admin',
                        path: '/admin',
                    },
                    {
                        breadcrumbName: 'Manage lookup lists',
                        path: '/admin/lookup-lists',
                    },
                    {
                        breadcrumbName: 'Invoice status',
                        path: '/admin/lookup-lists/invoice-status',
                    },
                ]}
            >
                <>
                    <Button type="primary" icon={<PlusCircleOutlined />} onClick={() => navigate('/admin/lookup-lists/invoice-status/add')}>
                        Add new option
                    </Button>
                </>
            </ContentHeader>

            <div className="page-content">
                <Table
                    size="small"
                    bordered={true}
                    loading={invoiceStatuses.fetchStatus === StatePieceStatus.IsFetching}
                    dataSource={invoiceStatuses.data.map((option, i) => {
                        return { ...option, key: i } as IInvoiceStatusLookupListTableRow;
                    })}
                    columns={columns}
                    pagination={{
                        defaultPageSize: 50,
                    }}
                />
            </div>
        </div>
    );
};
